import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

/** Monospace reference code — scannable down a column, never wraps. */
export const RefCode = ({ children }: { children: ReactNode }) => (
  <Typography
    component="span"
    variant="caption"
    sx={{
      fontFamily: 'monospace',
      fontSize: '0.8125rem',
      color: 'text.secondary',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Typography>
);
